import React from 'react';
import {
	View,
	StyleSheet,
	TouchableOpacity,
	useWindowDimensions,
	Modal,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import moment from 'moment';
import I18n from '../../components/shared/i18n/I18n.component';
import Typography from '../../components/shared/Typography/Typography.component';
import colors from '../../config/colors';
import AddRequestContainer from './AddRequestModal.container';

interface Props {
	visible: boolean;
	sheetProps: any;
	onClose: () => void;
}

const AddRequestBottomSheet = ({ visible, sheetProps, onClose }: Props) => {
	const { height: windowHeight } = useWindowDimensions();
	const { bottom: bottomInset } = useSafeAreaInsets();

	if (!visible && !sheetProps) return null;

	const date = sheetProps?.prevValues?.date
		? moment(sheetProps.prevValues.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
		: null;

	return (
		<Modal
			visible={visible}
			transparent
			animationType='slide'
			statusBarTranslucent
			onRequestClose={onClose}
		>
			<TouchableOpacity
				activeOpacity={1}
				onPress={onClose}
				style={styles.backdrop}
			/>
			<View style={[styles.sheetPanel, { height: windowHeight * 0.9, paddingBottom: bottomInset }]}>
				<View style={styles.header}>
					<View style={styles.handleBar} />
					<View style={styles.titleRow}>
						<TouchableOpacity
							onPress={onClose}
							hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
						>
							<Typography size={18} color='darkGrey'>
								✕
							</Typography>
						</TouchableOpacity>
						<View style={styles.titleTextRow}>
							<I18n
								weight='bold'
								size={14}
								color='primaryDarkBlue'
								style={{ letterSpacing: 0.15, marginLeft: 12 }}
							>
								{sheetProps?.isEdit
									? 'addReportModal.updateRequest'
									: 'addReportModal.createNewRequest'}
							</I18n>
							{date ? (
								<Typography
									size={14}
									weight='400'
									color='primaryDarkBlue'
									style={{ letterSpacing: 0.25 }}
								>
									{`   ${date}`}
								</Typography>
							) : null}
						</View>
						<View style={{ width: 24 }} />
					</View>
				</View>
				<View style={styles.content}>
					{sheetProps ? (
						<AddRequestContainer
							{...sheetProps}
							onNext={onClose}
							onCancel={(callback?: Function) => {
								sheetProps.onCancel(callback);
								onClose();
							}}
							onSubmit={async (callback?: Function) => {
								try {
									await sheetProps.onSubmit(callback);
								} finally {
									onClose();
								}
							}}
						/>
					) : null}
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	sheetPanel: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		backgroundColor: colors.white,
		borderTopLeftRadius: 20,
		borderTopRightRadius: 20,
	},
	header: {
		backgroundColor: colors.white,
		borderTopLeftRadius: 20,
		borderTopRightRadius: 20,
		paddingTop: 10,
		paddingHorizontal: 20,
		paddingBottom: 12,
		borderBottomWidth: 1,
		borderBottomColor: '#F0F0F0',
	},
	handleBar: {
		width: 40,
		height: 4,
		borderRadius: 2,
		backgroundColor: '#D1D4DC',
		alignSelf: 'center',
		marginBottom: 12,
	},
	titleRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	titleTextRow: {
		flexDirection: 'row-reverse',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 1,
	},
	content: {
		flex: 1,
		backgroundColor: colors.white,
	},
	backdrop: {
		...StyleSheet.absoluteFillObject,
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
	},
});

export default AddRequestBottomSheet;
